import { useMediaQuery, useTheme } from "@mui/material";
import { ToastContainer } from "react-toastify";

/**
 * Bottom-center toasts on small screens; top-right on md+.
 */
function ResponsiveToastContainer() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <ToastContainer
      position={isMobile ? "bottom-center" : "top-right"}
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      style={isMobile ? { bottom: "max(16px, env(safe-area-inset-bottom))" } : undefined}
    />
  );
}

export default ResponsiveToastContainer;
